import { Box } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import { REPORT_PAGE_HEIGHT } from '../PageConfigProvider/constants';

export const ReportWrapper = ({
  isReport = false,
  children,
}: { isReport?: boolean } & PropsWithChildren) => {
  if (!isReport) return children;
  return (
    <Box width="100%" height={`${REPORT_PAGE_HEIGHT}px`}>
      {children}
    </Box>
  );
};
